import {Recommendation} from './types';

const areRecommendationsEqual = (a: Recommendation[] = [], b: Recommendation[] = []) => {
    return (
        a.length === b.length && a.every(x => b.some(y => y.id === x.id)) && b.every(x => a.some(y => y.id === x.id))
    );
};

export default areRecommendationsEqual;
